import "core-js/modules/web.dom-collections.iterator.js";
import React, { cloneElement, useMemo } from 'react';
import { styled } from '@mui/material';
import ListItemCard from './ListItemCard';
import Box from '../Box';
const ListItemCardsContainer = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}));
const ItemCardContainer = styled(Box)(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    marginBottom: theme.spacing(3)
  };
});
function ListItemCards(_ref2) {
  let {
    getTitle,
    renderTitleAdornment,
    renderContent,
    renderActions,
    nodeIdKey,
    getRowID,
    selectable = false,
    selectionType = 'multiple',
    selectedIds,
    selectedIdsSet,
    onSelection,
    nodeSelectionIdKey,
    renderContainer,
    renderCardContainer,
    results,
    getCheckboxAriaLabel,
    nodeContext = {}
  } = _ref2;
  const realSelectedIds = useMemo(() => {
    if (selectedIdsSet) {
      return selectedIdsSet;
    }
    return new Set(selectedIds);
  }, [selectedIds, selectedIdsSet]);
  const renderCardContainerWithWrap = (node, index) => {
    const nodeId = node[nodeIdKey] || getRowID(node);
    const selectionId = node[nodeSelectionIdKey] || nodeId;
    const selected = realSelectedIds.has(selectionId);
    const Card = /*#__PURE__*/React.createElement(ListItemCard, {
      node: node,
      title: getTitle(node),
      renderTitleAdornment: renderTitleAdornment,
      renderContent: renderContent,
      renderActions: renderActions,
      selectable: selectable,
      isSelected: selected,
      onSelection: onSelection,
      selectionType: selectionType,
      getCheckboxAriaLabel: getCheckboxAriaLabel,
      nodeContext: nodeContext
    });
    if (typeof renderCardContainer === 'function') {
      const result = renderCardContainer({
        ItemCard: Card,
        node,
        isSelected: selected
      });
      const element = /*#__PURE__*/cloneElement(result, {
        key: nodeId
      });
      return element;
    }
    return /*#__PURE__*/React.createElement(ItemCardContainer, {
      key: nodeId
    }, Card);
  };
  const RenderCards = () => results.nodes.map((node, index) => renderCardContainerWithWrap(node, index));
  if (renderContainer) {
    return renderContainer({
      ItemCardList: /*#__PURE__*/React.createElement(React.Fragment, null, RenderCards())
    });
  }
  return /*#__PURE__*/React.createElement(ListItemCardsContainer, null, RenderCards());
}
export default ListItemCards;